import { render, staticRenderFns } from "./BasicLayout.vue?vue&type=template&id=04ffe5d2&scoped=true&lang=html"
import script from "./BasicLayout.vue?vue&type=script&lang=js"
export * from "./BasicLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ffe5d2",
  null
  
)

export default component.exports